import * as React from 'react';
import {useSelector} from 'react-redux';

import {AllLimitsModal} from './all-limits-modal';
import {IndividualFeatureLimitsModal} from './individual-feature-limits-modal';
import * as ModalState from './limits-selectors';

export function FeatureLimitsModal() {
    const isAllLimitsModalOpen = useSelector((state) => ModalState.getIsAllLimitsModalOpen(state));
    const modalType = useSelector((state) => ModalState.getLimitsModalType(state));

    return (
        <>
            {isAllLimitsModalOpen ? <AllLimitsModal /> : undefined}
            {modalType ? <IndividualFeatureLimitsModal modalType={modalType} /> : undefined}
        </>
    );
}
